import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { Badge, CustomButton, MobilePagination, Text } from '../../shared/uiComponents';
import { BadgeTypes, ClientStatusTypes } from '../../shared/uiComponents/StatusBadge';
import { UserTie } from '../../shared/Assets/menuIcons';
import { PRIMARY, TEXT } from '../../shared/Helpers/colors';
import { Loader, InfoRow as Row, Wrapper } from '../../components/StyledComponents';
import { ClientsDataProperties } from './tableInfo';
import { ClientInfo } from './clientInfo';

import { DispatchProperties } from '../../redux/store';
import { clearSkillAreas } from '../../redux/State/clientSlice/skillAreaSlice';

interface MobileViewProperties extends ClientsDataProperties {
	loading: boolean;
}

const MobileView: FC<MobileViewProperties> = (data) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { query, totalNumberOfItems, loading } = data;

	const navigateClientHandler = () => {
		dispatch(clearSkillAreas());
	};

	return (
		<div className="mobileView">
			{loading && <Loader />}
			{!loading && !totalNumberOfItems && (
				<div className="mobileView">
					<Text title="No results" type="plg" fontWeight="semiBold" className="marginAuto" />
				</div>
			)}
			{!loading &&
				query?.map((item) => (
					<Wrapper key={item.id}>
						<div className="clientMobileCardHeader">
							<div className="clientMobileCardHeaderLeft">
								<UserTie color={PRIMARY.BASE} />
								<Text title={item.fullName} type="pmd" fontWeight="medium" color={TEXT.PRIMARY} />
							</div>
							<Badge label={item.status.name} sizeType="sm" type={ClientStatusTypes[item.status.id] as BadgeTypes} />
						</div>

						<div className="clientMobileCardBody">
							<Row>
								<Text title="Email:" type="pxs" color={TEXT.TERTIARY} />
								<Text title={item.email} type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
							</Row>
							<Row>
								<Text title="Providers:" type="pxs" color={TEXT.TERTIARY} />
								<Text title={`${item.numberOfTherapist}`} type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
							</Row>
							<Row>
								<Text title="Parent phone:" type="pxs" color={TEXT.TERTIARY} />
								<Text
									title={item.parentPhoneNumber ? item.parentPhoneNumber : '-'}
									type="psm"
									fontWeight="medium"
									color={TEXT.SECONDARY}
								/>
							</Row>
						</div>

						<div className="clientMobileCardFooter">
							<div className="clientMobileCardFooterAction">
								<ClientInfo item={item} />
							</div>
							<Link to={`/clients/client/${item.id}`} onClick={navigateClientHandler} className="clientMobileCardLink">
								<CustomButton title="View More" buttonType="secondary" sizeType="sm" />
							</Link>
						</div>
					</Wrapper>
				))}
			<MobilePagination data={data} />
		</div>
	);
};

export default MobileView;
